export default __webpack_public_path__ + "static/media/painter.01d68d60.png";